import { useState } from "react";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";
import { all_routes } from "../../router/all_routes";

interface Props {
  show: boolean;
  onClose: () => void;
}

const CancelAuthentication = ({ show, onClose }: Props) => {
  const navigate = useNavigate();
  const [cancelReason, setCancelReason] = useState("");
  const [comments, setComments] = useState("");

  if (!show) return null;

  const handleSubmit = async () => {
    if (!cancelReason) {
      Swal.fire({
        icon: "warning",
        title: "Please select a reason",
      });
      return;
    }

    // ===== API CALL HERE LATER =====
    // await cancelAuthenticationAPI.callApi({
    //   reason: cancelReason,
    //   comments,
    // });

    await Swal.fire({
      icon: "success",
      title: "Success",
      text: "Cancel Request has been submitted.",
      confirmButtonText: "OK",
    });

    navigate(all_routes.addressInfo);
    // Close Modal
    onClose();
  };

  return (
    <div
      className="modal fade show d-block"
      tabIndex={-1}
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <h5 className="modal-title">Cancel Address Authentication</h5>

            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          {/* Body */}
          <div className="modal-body">
            <div className="mb-4">
              <label className="form-label fw-medium">
                Please select one of the following
                <span className="text-danger ms-1">*</span>
              </label>

              <select
                className="form-select"
                value={cancelReason}
                onChange={(e) => setCancelReason(e.target.value)}
              >
                <option value="">Select Reason</option>
                <option value="REINITIATE">Re-Initiate</option>
                <option value="NOT_AT_ADDRESS">Not At the Address</option>
                <option value="NOT_INTERESTED">Not Interested</option>
              </select>
            </div>

            <div>
              <label className="form-label fw-medium">Comments</label>

              <textarea
                rows={4}
                className="form-control"
                placeholder="Enter comments (Optional)"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              />
            </div>
          </div>

          {/* Footer */}
          <div className="modal-footer gap-2">
            <button className="btn btn-outline-primary l" onClick={onClose}>
              Close
            </button>

            <button className="btn btn-primary" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CancelAuthentication;
